import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const getCareAdvisorUserById = async (user_id: number): Promise<UserProfile> => {
  const { data } = await client.get(`/care_advisor/users/${user_id}`);

  return data;
};
